import React from 'react'
import TextInput from "../../../../Components/Form/TextInput/TextInput";
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import Description from "../../../../Components/Form/Description/Description";
import Button from "../../../../Components/Form/Button/Button";
import { formContent } from "./content"
import { useForm, FormProvider} from "react-hook-form";
import IdentityApi from "../../../../Api/IdentityApi";
import Link from "../../../../Components/Form/Link/Link";
import { useHistory } from "react-router-dom";
import {getResponseError, getUserDetailsCookie, setUserDetailsCookie} from "../../../../Api/Utils/apiUtils";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";
import SuccessAlert from "../../../../Components/Form/SuccessAlert/SuccessAlert";

const {
    heading,
    description,
    code,
    verifyButton,
    resendLink
} = formContent;

const VerifyOtpComponent = () => {
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [successMessage, setSuccessMessage] = React.useState(null);
    const formBinding = useForm();
    const { watch, handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));
    const history = useHistory();
    const user = getUserDetailsCookie();
    const { mobileNo } = user;
    const userId = user.id;
    const submitForm = async (data) => {
        setSuccessMessage('');
        const response = await IdentityApi.verifyOtp(userId, data.code);
        const apiError = getResponseError(response);
        if(apiError) {
            setErrorMessage(apiError);
        }else {
            user.isVerify = true;
            setUserDetailsCookie(user);
            history.push("/profile");
        }
    }
    const resendOtp = async () => {
        setSuccessMessage('');
        setErrorMessage('');
        const response = await IdentityApi.resendOtp(userId);
        const apiError = getResponseError(response);
        if(apiError) {
            setErrorMessage(apiError);
        }else {
            setSuccessMessage('OTP resent successfully');
        }
        return false;
    }
    return (
        <Section>
            <FormContainer>
                <Heading>{heading}</Heading>
                <Description>{description + ' ' + mobileNo}</Description>
                <SuccessAlert>{successMessage}</SuccessAlert>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <FormProvider {...formBinding}>
                    <form id="verify-otp-form" onSubmit={handleSubmit(submitForm)}>
                        <TextInput {...code} />
                        <Button {...verifyButton}/>
                        <Link {...resendLink} action={resendOtp}/>
                    </form>
                </FormProvider>
            </FormContainer>
        </Section>
    )
}

export default VerifyOtpComponent
